export default __webpack_public_path__ + "static/media/manage_profile.6d63ab76.svg";